import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar"
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import * as attachmentsActions from "../../redux/actions/attachmentsAction";
import DisplayEmployeeNameComponent from "../../components/DisplayEmployeeName";
import * as profileActions from "../../redux/actions/profileAction";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const DisplayEmployeeNameContainer = (props, context) => {
    const profileReducer = useSelector((state) => state.profileReducer);
    const commonReducer = useSelector((state) => state.commonReducer);
    const userAuthReducer = useSelector((state) => state.userAuthReducer);

    const dispatch = useDispatch();
    const commonAction = bindActionCreators(commonActions, dispatch);
    const userAuthAction = bindActionCreators(userAuthActions, dispatch);
    const attachmentsAction = bindActionCreators(attachmentsActions, dispatch);
    const profileAction = bindActionCreators(profileActions, dispatch);


    const getFileHistory = () => {
        //commonAction.getFileHistory(props.fileLevel);
    }
    const resetFileHistory = () => {
        commonAction.resetFileHistory();
    }

    const getAuthUserRoles = (companyId) => {
        userAuthAction.getAuthUserRoles(companyId);
    }

    const getAllCompanyList = () => {
        userAuthAction.getAllCompanyList();
    }

    const resetCompanyIdInManagerData = (companyId) => {
        profileAction.resetCompanyIdInManagerData(companyId,profileReducer);
    }

    const getAllActiveCases = () => {
        attachmentsAction.getAllActiveCases(profileReducer);
    }

    return (
        <>
            {/* <div className="Content-Panel"> */}
                {/* {commonReducer.fileHistory && commonReducer.fileHistory.length > 0 ? */}
                    <DisplayEmployeeNameComponent
                        managersDetails={profileReducer.managersDetails}
                        userAuthReducer={userAuthReducer}
                        context={props.context}
                        getAuthUserRoles={getAuthUserRoles}
                        getAllCompanyList={getAllCompanyList}
                        resetCompanyIdInManagerData={resetCompanyIdInManagerData}
                        getAllActiveCases={getAllActiveCases}
                    /> 
                {/* } */}
            {/* </div> */}
        </>
    )
}


export default DisplayEmployeeNameContainer;